import { Controller } from "@hotwired/stimulus"

// Auto-submits un form con debounce (500ms) y actualiza la URL del navegador
// incluyendo SOLO los parámetros con valor — omite los vacíos.
// Restaura el foco al input de búsqueda después de que el Turbo Frame recarga.
//
// Uso:
//   <form data-controller="admin--search-debounce" data-turbo-frame="frame_id">
//     <input type="text" data-action="input->admin--search-debounce#search">
//     <select data-action="change->admin--search-debounce#search">
export default class extends Controller {
  static values = { delay: { type: Number, default: 500 } }

  connect() {
    this._timeout = null
    this.#restoreFocusIfNeeded()
  }

  disconnect() {
    clearTimeout(this._timeout)
  }

  search(event) {
    this.#saveFocusState(event.target)
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this.#submit(), this.delayValue)
  }

  #saveFocusState(input) {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return
    frame.dataset.searchFocusName = input.name
    frame.dataset.searchCursor = input.selectionStart ?? ""
  }

  #restoreFocusIfNeeded() {
    const frame = this.element.closest("turbo-frame")
    if (!frame || !frame.dataset.searchFocusName) return

    const name = frame.dataset.searchFocusName
    const cursor = parseInt(frame.dataset.searchCursor, 10)
    delete frame.dataset.searchFocusName
    delete frame.dataset.searchCursor

    // Solo restaurar foco en inputs de texto, no en selects
    const input = this.element.querySelector(`input[name="${name}"]`)
    if (!input) return

    input.focus()
    if (!isNaN(cursor) && input.setSelectionRange) {
      input.setSelectionRange(cursor, cursor)
    }
  }

  #submit() {
    const form = this.element
    const data = new FormData(form)
    const params = new URLSearchParams()

    for (const [key, value] of data.entries()) {
      if (value !== "") params.set(key, value)
    }

    const query = params.toString()
    const url = query ? `${form.action}?${query}` : form.action
    history.pushState({}, "", url)

    form.requestSubmit()
  }
}
